var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { filter } from "lodash";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import { getBlacklistedTags, updateBlacklistedTags } from "@irati/permissions/services/packages";
import Loading from "@irati/ui/src/Loading";
import addOrRemoveFromArray from "@irati/utils/addOrRemoveFromArray";
import packageService from "@irati/deals/services/package";
import ListWrapper from "./styled/ListWrapper";
import TagListItem from "./TagListItem";
var TagList = /** @class */ (function (_super) {
    __extends(TagList, _super);
    function TagList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tags: [],
            blacklistedTags: [],
            load: hangPromise()
        };
        _this.handleToggle = function (uuid) {
            var newBlacklistedTags = addOrRemoveFromArray(_this.state.blacklistedTags, uuid);
            var tenant = authentication.userTenant();
            return updateBlacklistedTags({ tenant: tenant }, newBlacklistedTags).then(function (blacklist) {
                _this.props.onSave();
                _this.setState({ blacklistedTags: blacklist });
            });
        };
        _this.isTagBlackListed = function (uuid) {
            return _this.state.blacklistedTags.find(function (blacklistedTagUuid) { return blacklistedTagUuid === uuid; });
        };
        return _this;
    }
    TagList.prototype.componentDidMount = function () {
        var _this = this;
        var tenant = authentication.userTenant();
        var load = getBlacklistedTags({ tenant: tenant }).then(function (blacklist) {
            if (blacklist === void 0) { blacklist = []; }
            _this.setState({ blacklistedTags: blacklist });
            return packageService.dealTagsForCurrentPackage().then(function (tags) {
                _this.setState({ tags: filter(tags, function (tag) { return tag.filterable; }) });
            });
        });
        this.setState({ load: load });
    };
    TagList.prototype.render = function () {
        var _this = this;
        var _a = this.state, tags = _a.tags, load = _a.load;
        return (React.createElement(ListWrapper, null,
            React.createElement(Loading, { load: load }, tags.map(function (tag) { return (React.createElement(TagListItem, { key: tag.uuid, tag: tag, blacklisted: !!_this.isTagBlackListed(tag.uuid), handleToggle: _this.handleToggle })); }))));
    };
    return TagList;
}(Component));
export default TagList;
